module.exports = __webpack_public_path__ + "fa2772327f55d8198301fdb8bcfc8158.woff";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/glyphicons-halflings-regular.woff
// module id = 337
// module chunks = 0